import { snapshot, useSnapshot } from 'valtio';
import TagsStore from '../store/tags-store';
export {
  getEditApplicationsTagsData,
  submitEditApplicationsTags,
} from '../actions/edit-applications-tags-content-actions';
export { clearEditApplicationsTagsData } from '../store-actions/tags-store-actions';

export const useTagsStore = () => {
  return useSnapshot(TagsStore);
};

export const getTagsStore = () => {
  return snapshot(TagsStore);
};